import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';

const BackToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ opacity: 0, y: 20, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.8 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          whileHover={{ y: -4, boxShadow: '0 16px 50px -10px rgba(212,175,55,0.55)' }}
          whileTap={{ scale: 0.94 }}
          onClick={scrollTop}
          data-testid="back-to-top"
          aria-label="Înapoi sus"
          className="fixed bottom-6 right-6 md:bottom-10 md:right-10 z-40 w-12 h-12 md:w-14 md:h-14 rounded-full border border-gold/60 bg-obsidian/85 backdrop-blur-md text-gold flex items-center justify-center hover:bg-gold hover:text-obsidian transition-colors duration-500"
        >
          <ArrowUp className="w-4 h-4 md:w-5 md:h-5" strokeWidth={1.6} />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;
